var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-31"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-31",
    cx: 245.18,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.62,204s9.7,20.24,13.94,26.08c3.67,5.07,17.15,17.54,17.15,17.54l3.72-.4a2.85,2.85,0,0,1,2.85,1.53l.42.81a2.85,2.85,0,0,0,.68.86l.66.57a2.85,2.85,0,0,1,.72,3.41l-.51,1a2.84,2.84,0,0,1-2,1.56l-4,.82a2.86,2.86,0,0,1-2.77-1l-3.4-4.11s-17.94-13.15-22.54-18.88c-3.71-4.62-11-21-11-21Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.92,303.94a28.57,28.57,0,1,0-57.14,0Z",
    className: "colorToChange",
    style: {
      fill: "#9E9E9E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.92,303.94a28.57,28.57,0,1,0-57.14,0Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.9,294.71a2.26,2.26,0,0,1-2.88-1,21.29,21.29,0,0,0-37.34,0,2.27,2.27,0,0,1-2.88,1h0a2.24,2.24,0,0,1-1.11-3.11,25.79,25.79,0,0,1,45.32,0,2.25,2.25,0,0,1-1.11,3.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M198.05,219.37,179,283.15a21.53,21.53,0,0,1,2.87.85q7.94-26.55,15.86-53.1l3.21-10.73C201.5,218.31,198.6,217.52,198.05,219.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.05,219.37,179,283.15a21.53,21.53,0,0,1,2.87.85q7.94-26.55,15.86-53.1l3.21-10.73C201.5,218.31,198.6,217.52,198.05,219.37Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.8,266.79q6.93-23.22,13.87-46.42c.83-2.78-3.52-4-4.34-1.2q-6.95,23.21-13.87,46.42c-.83,2.78,3.51,4,4.34,1.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.26,303.94h62.27a7.87,7.87,0,0,1,7.87,7.87v96.51a0,0,0,0,1,0,0h-78a0,0,0,0,1,0,0V311.81A7.87,7.87,0,0,1,143.26,303.94Z",
    className: "colorToChange",
    style: {
      fill: "#9E9E9E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.26,303.94h62.27a7.87,7.87,0,0,1,7.87,7.87v96.51a0,0,0,0,1,0,0h-78a0,0,0,0,1,0,0V311.81A7.87,7.87,0,0,1,143.26,303.94Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.39 386.17 181.39 405.17 189.82 402.83 186.22 382.5 176.39 386.17",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.47,400.79a.25.25,0,0,1-.22-.13.22.22,0,0,1,.05-.25c.11-.12,2.74-2.74,4.34-2.74a1.16,1.16,0,0,1,.8.31.83.83,0,0,1,.27.92c-.24.58-1.33,1.09-2.44,1.39A16.6,16.6,0,0,1,191.47,400.79Zm.61-.47c1.72-.25,4-.88,4.22-1.57,0-.09.06-.23-.17-.45a.61.61,0,0,0-.49-.19,1.42,1.42,0,0,0-.42.06A10.09,10.09,0,0,0,192.08,400.32Z",
    className: "colorToChange",
    style: {
      fill: "#9E9E9E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.36,400.8a.19.19,0,0,1-.15-.16c0-.12-.44-2.59.45-3.83a1.65,1.65,0,0,1,1.07-.69c.6-.1.86.15,1,.39.47.95-1.15,3.47-2.09,4.23a.12.12,0,0,1-.09,0A.17.17,0,0,1,191.36,400.8Zm1.34-4.24a1.16,1.16,0,0,0-.66.47,5.2,5.2,0,0,0-.44,3.06c.93-1,1.93-2.85,1.71-3.44,0,0-.1-.2-.49-.13l-.12,0Z",
    style: {
      fill: "#9E9E9E"
    },
    className: "colorToChange"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.22,399.78l-9.74,2.66a.81.81,0,0,0-.6.82l.4,8.41a1.34,1.34,0,0,0,1.4,1.29.86.86,0,0,0,.28,0c3.5-1,6.57-2.06,10.95-3.25,5.16-1.4,4-.43,10.11-2,3.66-.95,3.2-5.29,1.6-5.07-7.34,1-8.66-.9-12.09-2.69A3.23,3.23,0,0,0,190.22,399.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.97 381.53 74.93 399.46 82.96 402.94 92.92 384.85 82.97 381.53",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.53,402.38a.22.22,0,0,1-.09-.24.2.2,0,0,1,.19-.16c.16,0,3.86-.41,5.1.6a1.15,1.15,0,0,1,.43.74.83.83,0,0,1-.37.88c-.55.3-1.72,0-2.77-.44A16.79,16.79,0,0,1,85.53,402.38Zm.77,0c1.49.89,3.63,1.81,4.27,1.43.08,0,.19-.14.15-.45a.61.61,0,0,0-.27-.45,1.25,1.25,0,0,0-.37-.22A10.25,10.25,0,0,0,86.3,402.39Z",
    style: {
      fill: "#9E9E9E"
    },
    className: "colorToChange"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.43,402.32a.2.2,0,0,1,0-.22c0-.1,1.28-2.29,2.75-2.7a1.65,1.65,0,0,1,1.27.14c.53.3.58.66.5.9-.24,1-3.08,2-4.29,2a.16.16,0,0,1-.09,0A.21.21,0,0,1,85.43,402.32Zm3.71-2.45a1.08,1.08,0,0,0-.81-.05,5.1,5.1,0,0,0-2.26,2.1c1.32-.16,3.29-1,3.49-1.61,0-.06,0-.21-.3-.4l-.12,0Z",
    style: {
      fill: "#9E9E9E"
    },
    className: "colorToChange"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.18,400.81l-9.25-4.05a.83.83,0,0,0-1,.26l-5,6.8a1.36,1.36,0,0,0,.28,1.89,2,2,0,0,0,.25.14c3.36,1.41,6.4,2.52,10.55,4.35,4.9,2.15,3.4,2.19,9.12,4.79,3.45,1.57,5.82-2.1,4.43-2.94-6.36-3.79-6.17-6.13-7.71-9.68A3.24,3.24,0,0,0,85.18,400.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.79,164.77s6.85-2.1,5.13-5.23c-1.5-2.71-4,.56-4,.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.79,164.77s6.85-2.1,5.13-5.23c-1.5-2.71-4,.56-4,.56Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.87 187.72 148.54 194.06 139.11 190.84 141.93 183.56 149.87 187.72",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.21,190.88a5.53,5.53,0,0,1-2.75-3.67l1.55-.47,1.86,1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.32,171.64c.06.57-.2,1.06-.58,1.09s-.76-.43-.79-1,.2-1.05.58-1.07S160.27,171.08,160.32,171.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.24,173.42l3.21,4.21a4,4,0,0,1-3.54.58Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.72,171.08c.36,7.57.34,10.78,4.18,14.77,5.9,4.11,15.2,4,17.15-3.46,1.76-6.74.88-18-6.64-21.22a10.53,10.53,0,0,0-13.86,5.24A10.12,10.12,0,0,0,137.72,171.08Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.5,166.6a.32.32,0,0,0-.22.19,2.33,2.33,0,0,1-1.56,1.46.3.3,0,0,0-.24.35.32.32,0,0,0,.37.23,2.84,2.84,0,0,0,2-1.82.3.3,0,0,0-.17-.39h0A.37.37,0,0,0,159.5,166.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.19,193.16l1.91-2.23a4.39,4.39,0,0,1,4.81-1.25l6.52,2.35a4.38,4.38,0,0,1,2.69,2.8l.74,2.33Z",
    style: {
      fill: "#9E9E9E"
    },
    className: "colorToChange"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.19,193.16l1.91-2.23a4.39,4.39,0,0,1,4.81-1.25l6.52,2.35a4.38,4.38,0,0,1,2.69,2.8l.74,2.33Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.12,250.44s22.34,55.87,27.93,75.23c4.56,15.75,13.77,64.33,13.77,64.33l-14,3.57s-12.17-47.71-17.46-63.24c-4.48-13.14-16-39.22-25.57-49.3-1.61-1.7-6.14-3.61-7.7-5.36-3.21-3.62-6.92-12.93-7.93-17.67-.46-2.16,0-8.83,0-8.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.12,250.44s-5.34,16.95-7.65,22.39c-1.24,2.95-4.36,8.57-5.58,11.52-5.74,13.85-14.84,42.7-20.07,56.49-5.16,13.57-24.35,52.73-24.35,52.73L77.8,388s16.25-39.26,20.67-52.7c4.31-13.08,10.74-40,12.47-53.64.53-4.22.29-12.76.7-17,.37-3.9,2.33-15.5,2.33-15.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.63,250.53l36.63,5.11L158.68,205a7.26,7.26,0,0,0-5.35-8.23l-16.23-4.21a10.78,10.78,0,0,0-13.27,8.26Z",
    style: {
      fill: "#9E9E9E"
    },
    className: "colorToChange"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.37 224.91 156.99 215.16 150.31 209.5 155.37 224.91",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.81 384.54 75.93 388.92 90.56 395.67 92.68 391.54 77.81 384.54",
    style: {
      fill: "#9E9E9E"
    },
    className: "colorToChange"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.06 391.11 175.39 395.68 190.97 391.61 190 387.07 174.06 391.11",
    style: {
      fill: "#9E9E9E"
    },
    className: "colorToChange"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.89,176s2-2.56.54-6.69,7-12.76,1.63-15.3c-3.34-1.58-4.31,2.87-4.31,2.87s-2.05-3.19-5-1.86c-1.7.77-1.25,3-1.25,3s-12.06,1.91-9.55,13.09a15.9,15.9,0,0,0,4.48,13s4.35-1.59,7.93.64C148.38,184.76,148.82,180.15,153.89,176Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.08,172.82s-3.79-3.06-4.09-6.2S136,168.79,137.08,172.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.28,173.14a5.85,5.85,0,0,1,1.94,4.06c.08,2.06-1.92,2.6-3.64,1.62s-3.48-3-2.73-4.88A2.7,2.7,0,0,1,153.28,173.14Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.18,264.55c1.46,11,8.81,21.7,12.92,27,1-2.66,1.93-5.08,2.79-7.17C122.39,274.22,119.18,264.55,119.18,264.55Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.3,200.44s9.25,16.12,13.73,20.62c3.88,3.88,18.84,12.87,18.84,12.87l5.08-.09a2.61,2.61,0,0,1,2.13,1h0a2.64,2.64,0,0,0,1.22.89l.44.16a2.61,2.61,0,0,1,1.73,2.83l-.3,2.18a2.62,2.62,0,0,1-1.81,2.13l-4.09,1.29a2.6,2.6,0,0,1-2.47-.5l-5.07-4.3s-18.72-8-23.66-12.56c-3.71-3.39-10.95-16.84-10.95-16.84Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.79,199.14l9.9,12.94L155,219.77l-7.75-13.48a5.44,5.44,0,0,1,1.41-7l1.47-1.12A5.44,5.44,0,0,1,157.79,199.14Z",
    style: {
      fill: "#9E9E9E"
    },
    className: "colorToChange"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.c53cd85b6d7f1c9a3baa027ec73bc89a.svg";
export { ForwardRef as ReactComponent };